const arrayToObject = (array = [], key = null) => {
  if (!key) {
    throw new Error('Invalid parameter [key]');
  }

  if (!array.length) return {};
  return array.reduce((obj, item) => {
    return Object.assign({}, obj, {
      [item[key]]: item
    });
  }, {});
};

export default arrayToObject;